import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';
import { HelpersService } from '@base/shared/services/helpers.service';

@Injectable()
export class WalkthroughServices {
  private config = environment;

  constructor(
    private http: AppHttpClient,
    private helpers: HelpersService
  ) {
  }


  /**
   * POST Create Contract Walkthrough
   */
  createContractWalkthrough(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/contract/${payload.contractId}`;
    return this.http.post(url, payload).toPromise();
  }


  /**
   * GET List Contracts Walkthroughs
   */
  contractWalkthroughList(payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/list`;
    return this.http.get(url, payload).toPromise();
  }


  /**
   * PATCH Update Contract Walkthrough Notes
   * @param contractWalkthroughId
   * @param walkthroughSectionNoteId
   * @param payload
   */
  contractWalkthroughPatch(contractWalkthroughId, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${contractWalkthroughId}`;
    return this.http.patch(url, payload).toPromise();
  }




  /**
   * GET Show Contracts Walkthrough
   */
  contractWalkthroughShow(contractWalkthroughId, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${contractWalkthroughId}/show/${query}`;
    return this.http.get(url).toPromise();
  }


  /**
   * POST Create Contract Walkthrough Notes
   * @param contractWalkthroughId
   * @param payload
   */
  createContractWalkthroughNotes(contractWalkthroughId, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${contractWalkthroughId}/notes`;
    return this.http.post(url, payload).toPromise();
  }

  /**
   * GET Show Contracts Walkthrough Notes
   * @param contractWalkthroughId
   * @param walkthroughSectionNoteId
   */
  getContractWalkthroughNote(contractWalkthroughId, walkthroughSectionNoteId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${contractWalkthroughId}/notes/${walkthroughSectionNoteId}/show`;
    return this.http.get(url).toPromise();
  }

  /**
   * PATCH Update Contract Walkthrough Notes
   * @param contractWalkthroughId
   * @param walkthroughSectionNoteId
   * @param payload
   */
  pathContractWalkthroughNote(contractWalkthroughId, walkthroughSectionNoteId, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${contractWalkthroughId}/notes/${walkthroughSectionNoteId}`;
    return this.http.patch(url, payload).toPromise();
  }


  /**
   * DETETE Contract Walkthrough Notes
   * @param contractWalkthroughId
   * @param walkthroughSectionNoteId
   * @param payload
   */
  deleteContractWalkthroughNote(contractWalkthroughId, walkthroughSectionNoteId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${contractWalkthroughId}/notes/${walkthroughSectionNoteId}`;
    return this.http.delete(url).toPromise();
  }

  /**
   * GET Show Contracts Walkthrough Photo
   * @param contractWalkthroughId
   * @param walkthroughSectionNoteAttachmentId
   */
  contractWalkthroughPhotosList(contractWalkthroughId, walkthroughSectionNoteAttachmentId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${contractWalkthroughId}/photos/${walkthroughSectionNoteAttachmentId}`;
    return this.http.get(url).toPromise();
  }


  /**
   * POST Create Contract Walkthrough Photo
   * @param contractWalkthroughId
   * @param payload
   */
  createContractWalkthroughPhoto(contractWalkthroughId, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${contractWalkthroughId}/photos`;
    return this.http.post(url, payload).toPromise();
  }
  /**
   * POST Create Contract Walkthrough Photo
   * @param contractWalkthroughId
   * @param payload
   */
  updateContractWalkthroughPhoto(contractWalkthroughId, photoId, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${contractWalkthroughId}/photos/${photoId}`;
    return this.http.post(url, payload).toPromise();
  }


  /**
   * GET Show Contracts Walkthrough Photo
   * @param contractWalkthroughId
   * @param walkthroughSectionPhotoAttachmentId
   */
  getContractWalkthroughPhoto(contractWalkthroughId, walkthroughSectionPhotoAttachmentId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${contractWalkthroughId}/photos/${walkthroughSectionPhotoAttachmentId}/show`;
    return this.http.get(url).toPromise();
  }


  /**
   * DETETE Contract Walkthrough Photos
   * @param contractWalkthroughId
   * @param walkthroughSectionNoteId
   * @param payload
   */
  deleteContractWalkthroughPhoto(contractWalkthroughId, walkthroughSectionNoteId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${contractWalkthroughId}/photos/${walkthroughSectionNoteId}`;
    return this.http.delete(url).toPromise();
  }


  /**
  * GET Show Questionaire
  * @param contractWalkthroughId
  * @param payload
  */
  getContractWalkthroughQuestionnaireShow(contractWalkthroughId, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${contractWalkthroughId}/questionnaire/${query}`;
    return this.http.get(url).toPromise();
  }


  /**
   * PUT Answer Safety Questionnaire
   * @param contractWalkthroughId
   * @param payload
   */
  putContractWalkthroughQuestionnaire(contractWalkthroughId, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${contractWalkthroughId}/questionnaire/answer`;
    return this.http.put(url, payload).toPromise();
  }


  /**
   * Submit daily log for a submitter
   * @param id daily log id
   * @param payload operation payload
   */
  submitDailyLogSubmitter(id, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${id}/submit`;
    return this.http.patch(url, payload);
  }

  deleteWalkkthrough(contractWalkthroughId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contract_walkthroughs}/${contractWalkthroughId}`;
    return this.http.delete(url).toPromise();
  }
  
}
